import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { PaginationService } from 'src/app/core/services/pagination.service';
import Swal from 'sweetalert2';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html',
  styleUrls: ['./inventory.component.scss'],
  standalone: false
})
export class InventoryComponent implements OnInit {

  // Breadcrumb
  breadCrumbItems!: Array<{}>;
  
  // Data
  inventoryItems: any[] = [];
  allInventoryItems: any[] = [];
  categories: any[] = [];
  isLoading = false;
  
  // Pagination from API
  currentPage: number = 1;
  perPage: number = 100;
  total: number = 0;
  lastPage: number = 1;
  
  // Filters
  searchTerm: string = '';
  categoryFilter: string = '';
  isActiveFilter: boolean = true;
  
  // Math reference for template
  Math = Math;
  parseFloat = parseFloat;
  
  constructor(
    private apiService: ApiService,
    public paginationService: PaginationService
  ) { }

  ngOnInit(): void {
    // Breadcrumb
    this.breadCrumbItems = [
      { label: 'Stock Management' },
      { label: 'Inventory', active: true }
    ];

    // Load data
    this.loadCategories();
    this.loadInventory();
  }

  /**
   * Load Categories
   */
  loadCategories(): void {
    this.apiService.get('/category_list').subscribe({
      next: (response: any) => {
        if (response.success) {
          this.categories = response.data || [];
        } else {
          this.categories = [];
        }
      },
      error: (error) => {
        console.error('Error loading categories:', error);
        this.categories = [];
      }
    });
  }

  /**
   * Load Inventory Items
   */
  loadInventory(): void {
    this.isLoading = true;
    
    // Build query parameters
    const params = `page=${this.currentPage}&limit=${this.perPage}&category_id=${this.categoryFilter}&is_active=${this.isActiveFilter}&search=${this.searchTerm}`;
    
    this.apiService.get(`/inventory_detail?${params}`).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        
        if (response.success) {
          this.inventoryItems = response.data || [];
          this.total = response.total || 0;
          this.currentPage = response.currentPage || 1;
          this.perPage = response.perPage || 100;
          this.lastPage = response.lastPage || 1;
        } else {
          this.inventoryItems = [];
          this.total = 0;
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error loading inventory:', error);
        Swal.fire('Error', 'Failed to load inventory items', 'error');
      }
    });
  }



  /**
   * Filter by category
   */
  filterByCategory(): void {
    this.currentPage = 1; // Reset to first page on filter
    this.loadInventory();
  }

  
  /**
   * Change page
   */
  changePage(page: number): void {
    this.currentPage = page;
    this.loadInventory();
  }

  /**
   * Refresh data
   */
  refreshData(): void {
    this.searchTerm = '';
    this.categoryFilter = '';
    this.isActiveFilter = true;
    this.currentPage = 1;
    this.loadInventory();
  }

  /**
   * Get stock status badge class
   */
  getStockStatusClass(currentStock: number, orderedQty: number): string {
    const stock = parseFloat(currentStock.toString());
    
    if (stock === 0) {
      return 'bg-danger-subtle text-danger';
    } else if (stock < 10) {
      return 'bg-warning-subtle text-warning';
    } else if (orderedQty > 0) {
      return 'bg-info-subtle text-info';
    } else {
      return 'bg-success-subtle text-success';
    }
  }


}
